import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import Container from '@mui/material/Container';
import NewSales from './creditForm'
import Popup from "../../../utilities/Popup";
import debtor from '../../../../assets/images/Credit-sales.svg'
import SelectPayment from "../payment/SelectPayment";
import { store } from "../../../../redux-store/store";
const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
};

export default function BasicModal({ amount, cartItems, drop }) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [openPopup, setOpenPopup] = useState(false);
    const [paymentPopup, setpaymentPopup] = useState(false);

    var credit = store.getState().persistReducer.credit
    return (
        <div>
            <Button variant="contained" style={{ backgroundColor: "#3f51b5" }} onClick={handleOpen}>
                Checkout
            </Button>
            {credit.isCredit && <Modal
                open={open}
                className=""
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box className="rounded-lg" sx={style}>


                    <Container className="text-center flex justify-center items-center">
                        <div className="text-center flex justify-center items-center mb-3">
                            <img src={debtor} alt="" className="w-3/5" />
                        </div>
                        <h4 id="modal-modal-title" className="text-center text-[#3F51B5] " variant="h6" component="h2">
                            <strong>Do you want to pay on Credit</strong>
                        </h4>
                        <div className="flex space-x-3 justify-center w-full mt-5">
                            <div>
                                <Button variant="contained" className="rounded-lg bg-[#3F51B5]" onClick={setOpenPopup}>
                                    Yes
                                </Button>
                            </div>
                            <div>
                                <Button variant="contained" className="rounded-lg bg-red-500" onClick={setpaymentPopup}>
                                    No
                                </Button>
                            </div>
                        </div>
                    </Container>


                    <Popup
                        title="Credit Sales Form"
                        setOpenPopup={setOpenPopup}
                        openPopup={openPopup}
                    >
                        <NewSales cartItems={cartItems} drop={drop} amount={amount} setOpenPopup={setOpenPopup} />
                    </Popup>
                    <Popup
                        title="Continue with Sales"
                        setOpenPopup={setpaymentPopup}
                        openPopup={paymentPopup}
                    >
                        <SelectPayment setpaymentPopup={setpaymentPopup} />
                    </Popup>
                </Box>
            </Modal>}



            {!credit.isCredit && <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>


                    <Container className="p-3">

                        <div className="row">

                            <div className="col">
                                <Button variant="contained" className="bg-success" onClick={setpaymentPopup}>
                                    Proceed
                                </Button>
                            </div>
                        </div>
                    </Container>


                    <Popup
                        title="Credit Sales Form"
                        className="text-[#3F51B5]"
                        setOpenPopup={setOpenPopup}
                        openPopup={openPopup}
                    >
                        <NewSales cartItems={cartItems} drop={drop} amount={amount} setOpenPopup={setOpenPopup} />
                    </Popup>
                    <Popup
                        title="Continue with Sales"
                        setOpenPopup={setpaymentPopup}
                        openPopup={paymentPopup}
                    >
                        <SelectPayment setpaymentPopup={setpaymentPopup} />
                    </Popup>
                </Box>

            </Modal>}
        </div>
    );
}
